var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharityGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.1,89.18c13.7-3.19,13.92-4.24,20-6.89,3.41-1.74,6.36-6.61,6.68-10.47.16-1.94-1.06-2.65-2.74-1.69.68-.42,1.36-.84,2-1.28,3.34-2,6.23-7.13,6.56-11,.16-1.94-1-2.53-2.68-1.44.67-.5,1.34-1,2-1.53,3.27-2.31,6.09-7.65,6.41-11.52.16-1.93-1-2.41-2.6-1.17a77,77,0,0,1-33,15.19l-6,.55a3.78,3.78,0,0,0-3.11,1.29,6.17,6.17,0,0,0-1.55,3.67,6.24,6.24,0,0,0,.92,3.9,15.39,15.39,0,0,1,1.56,7.37,40.2,40.2,0,0,1-1.5,9c-.25,3,1.44,5.53,3.77,5.74Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.13,63.39a79.53,79.53,0,0,0,12.78-7",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2 12 2 2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.43,74.34A79.85,79.85,0,0,0,140,70.13",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2 4 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,68.47c.18-2.18,1.72-3.82,3.44-3.67l4.77-.35",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,66.8a6.24,6.24,0,0,1-.92-3.9,6.17,6.17,0,0,1,1.55-3.67,3.78,3.78,0,0,1,3.11-1.29l6-.55a77,77,0,0,0,33-15.19c1.61-1.24,2.76-.76,2.6,1.17,0,1.63-6.68,5.57-9.95,7.88-9,6.55-23.75,9.18-23.75,9.18l-4.76.36c-1.72-.16-3.26,1.48-3.44,3.66,0,0,.6,2.8-.44,3.22S110.28,68.5,109,66.8Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,89.18c13.7-3.19,13.92-4.24,20-6.89,3.41-1.74,6.36-6.61,6.68-10.47.16-1.94-1.06-2.65-2.74-1.69.68-.42,1.36-.84,2-1.28,3.34-2,6.23-7.13,6.56-11,.16-1.94-1-2.53-2.68-1.44.67-.5,1.34-1,2-1.53,3.27-2.31,6.09-7.65,6.41-11.52.16-1.93-1-2.41-2.6-1.17a77,77,0,0,1-33,15.19l-6,.55a3.78,3.78,0,0,0-3.11,1.29,6.17,6.17,0,0,0-1.55,3.67,6.24,6.24,0,0,0,.92,3.9,15.39,15.39,0,0,1,1.56,7.37,40.2,40.2,0,0,1-1.5,9c-.25,3,1.44,5.53,3.77,5.74Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.9,89.18C30.2,86,30,84.94,23.94,82.29c-3.41-1.74-6.36-6.61-6.68-10.47-.16-1.94,1.06-2.65,2.74-1.69-.68-.42-1.36-.84-2-1.28-3.34-2-6.23-7.13-6.56-11-.16-1.94,1-2.53,2.68-1.44-.67-.5-1.34-1-2-1.53C8.82,52.58,6,47.24,5.68,43.37c-.16-1.93,1-2.41,2.6-1.17a77,77,0,0,0,33,15.19l6,.55a3.78,3.78,0,0,1,3.11,1.29,6.17,6.17,0,0,1,1.55,3.67A6.24,6.24,0,0,1,51,66.8a15.39,15.39,0,0,0-1.56,7.37,40.2,40.2,0,0,0,1.5,9c.25,3-1.44,5.53-3.77,5.74Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.87,63.39a79.53,79.53,0,0,1-12.78-7",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2 12 2 2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.57,74.34A79.85,79.85,0,0,1,20,70.13",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2 4 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.25,68.47c-.18-2.18-1.72-3.82-3.44-3.67L35,64.45",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,66.8a6.24,6.24,0,0,0,.92-3.9,6.17,6.17,0,0,0-1.55-3.67,3.78,3.78,0,0,0-3.11-1.29l-6-.55a77,77,0,0,1-33-15.19c-1.61-1.24-2.76-.76-2.6,1.17,0,1.63,6.68,5.57,9.94,7.88,9,6.55,23.76,9.18,23.76,9.18l4.76.36c1.72-.16,3.26,1.48,3.44,3.66,0,0-.6,2.8.44,3.22S49.72,68.5,51,66.8Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9,89.18C30.2,86,30,84.94,23.94,82.29c-3.41-1.74-6.36-6.61-6.68-10.47-.16-1.94,1.06-2.65,2.74-1.69-.68-.42-1.36-.84-2-1.28-3.34-2-6.23-7.13-6.56-11-.16-1.94,1-2.53,2.68-1.44-.67-.5-1.34-1-2-1.53C8.82,52.58,6,47.24,5.68,43.37c-.16-1.93,1-2.41,2.6-1.17a77,77,0,0,0,33,15.19l6,.55a3.78,3.78,0,0,1,3.11,1.29,6.17,6.17,0,0,1,1.55,3.67A6.24,6.24,0,0,1,51,66.8a15.39,15.39,0,0,0-1.56,7.37,40.2,40.2,0,0,0,1.5,9c.25,3-1.44,5.53-3.77,5.74Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 58.83,
    y1: 35.41,
    x2: 43.98,
    y2: 17.32,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.97,
    y1: 40.14,
    x2: 135.91,
    y2: 31.14,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.39,
    y1: 35.99,
    x2: 94.3,
    y2: 14.83,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6,
    y1: 35.99,
    x2: 67.11,
    y2: 10.6,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.93,
    y1: 40.67,
    x2: 25.26,
    y2: 30.55,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.85,
    y1: 35.6,
    x2: 118.53,
    y2: 18.99,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,67.12a21.09,21.09,0,0,0-29.82,0A21.09,21.09,0,1,0,50,97l29.82,29.82L109.61,97A21.09,21.09,0,0,0,109.61,67.12Z",
    fill: "#ffea80",
    stroke: "#ffd500",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.66,82.05a16,16,0,0,0-16-16",
    fill: "none",
    stroke: "#ffd500",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "2 4 24 3 18 4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharityGoal);
export default __webpack_public_path__ + "static/media/charity-goal.1c8b9e18.svg";
export { ForwardRef as ReactComponent };